
<v-app style="background-color: #fff;">
  <transition name="fade">
    <router-view v-if="refreshedLogin" />
  </transition>
</v-app>
